import React from 'react';

import RequestDetailPage from './RequestDetailPage';
import { waitingShipmentsFallbackDetails } from './requestQueueFallbacks';


export default function WaitingShipmentsDetailPage() {
    return (
        <RequestDetailPage
            title="Ожидание отправок"
            backTo="/app/shipments/waiting"
            backLabel="Назад к отправкам"
            mode="shipments"
            fallbackDetails={waitingShipmentsFallbackDetails}
        />
    );
}
